import mem from "mem";
import axios from "axios";
import store from "@/store";
import { getCookie } from "@/assets/js/utils/helpers";
import { BUSINESS_ROLES_ENG, EVISO_ROLES } from "@/assets/js/utils/consts";

const axiosPublic = axios.create({
  baseURL: "/api/v1/",
});

const refreshTokenFn = async () => {
  if (!getCookie("UserId")) {
    store.dispatch("setLogin", { value: false });
    return;
  }

  let url;
  const role = getCookie("UserRole");

  switch (true) {
    case EVISO_ROLES.includes(role):
      url = "eviso/refresh";
      break;
    case BUSINESS_ROLES_ENG.includes(role):
      url = "biz/refresh";
      break;
    default:
      url = "client/refresh";
      break;
  }

  try {
    const response = await axiosPublic.get(url);

    return response.data;
  } catch (error) {
    store.dispatch("setLogin", { value: false });
  }
};

export const memoizedRefreshToken = mem(refreshTokenFn, {
  maxAge: 10000,
});
